import { DatePicker, RangePickerProps } from 'components/DatePicker';
import FormItem from 'antd/lib/form/FormItem';
import { useMemo, useRef } from 'react';
import { useTranslate } from '@tolgee/react';
import { useMemoizedFn } from 'ahooks';
import dayjs, { Dayjs } from 'lib/dayjs';

interface ApplyDateFormFieldProps {
  filterType: 'return' | 'cancel';
  form: any;
  disabled?: boolean;
  disabledDate?: RangePickerProps['disabledDate'];
}

export const ApplyDateFormField = (props: ApplyDateFormFieldProps) => {
  const { form, filterType, disabled, disabledDate } = props;
  const { t } = useTranslate();
  const isCancel = useMemo(() => filterType === 'cancel', [filterType]);
  const dateRangeRef = useRef<[Dayjs, Dayjs]>();

  const handleDatePickerOpenChange = useMemoizedFn((visible) => {
    const dateRange = form.getFieldValue('dateRange');

    if (visible) {
      dateRangeRef.current = dateRange;

      form.setFieldsValue({
        dateRange: undefined,
      });
    } else {
      if (!dateRange) {
        form.setFieldsValue({
          dateRange: dateRangeRef.current,
        });
      }
    }
  });
  const handleDatePickerChange = useMemoizedFn((dates) => {
    form.setFieldsValue({ dateRange: dates ?? [] });
  });
  const disableDate = useMemoizedFn((current: Dayjs) => {
    const dates = form.getFieldValue('dateRange');
    const bigThanToday = current.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days') > 0;
    if (!dates) {
      return bigThanToday;
    }
    const tooLate = dates[0] && current.diff(dates[0], 'days') > (isCancel ? 13 : 90);
    const tooEarly = dates[1] && dates[1].diff(current, 'days') > (isCancel ? 13 : 90);
    return !!tooEarly || !!tooLate || bigThanToday;
  });

  return (
    <FormItem label={isCancel ? t('filter.createDate') : t('filter.date')} name="dateRange">
      <DatePicker.RangePicker
        disabled={disabled}
        allowClear={false}
        onCalendarChange={handleDatePickerChange}
        onChange={handleDatePickerChange}
        onOpenChange={handleDatePickerOpenChange}
        disabledDate={disabledDate || disableDate}
      />
    </FormItem>
  );
};
